import React, { Fragment } from 'react';
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import { setModalData, showModal } from "@redux-action/reduxConfirmModal";

function ReduxConfirmModal() {
    const dispatch = useDispatch();
    const { show, title, body, onConfirm, clonedEvent, confirmText, closeText } = useSelector(state => ({
        show: state.reduxConfirmModal.show,
        title: state.reduxConfirmModal.title,
        body: state.reduxConfirmModal.body,
        onConfirm: state.reduxConfirmModal.onConfirm,
        clonedEvent: state.reduxConfirmModal.clonedEvent,
        confirmText: state.reduxConfirmModal.confirmText,
        closeText: state.reduxConfirmModal.closeText
    }));

    const onHide = () => {
        dispatch(showModal(false));
        dispatch(setModalData({
            title: 'Please Confirm',
            body: null,
            onConfirm: null,
            hasConfirm: false,
            confirmText: 'Confirm',
            closeText: 'Close'
        }));
    };

    const handleOnConfirm = () => {
        onConfirm(clonedEvent);
        onHide();
    };

    return (
        <Fragment>
            <Modal
                centered
                backdrop="static"
                size="lg"
                show={show}
                onHide={onHide}
                aria-labelledby="generic-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="generic-modal">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>{body ? body() : '...'}</Modal.Body>
                <Modal.Footer>
                    <Button onClick={onHide}>{closeText}</Button>
                    {onConfirm && <Button variant="success" onClick={handleOnConfirm}>{confirmText}</Button>}
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
}

export default ReduxConfirmModal;
